module.exports = __webpack_public_path__ + "static/media/hengshan.44d85c20.webp";